import { useEffect, useRef } from 'react';

/**
 * Scrolls the nearest scrollable ancestor so the feed “follows” new SSE rows (chat-style).
 * Attach the returned ref to a zero-height sentinel placed after the last card.
 */
export function useScrollStreamFeedBottom({ count = 0, enabled = true } = {}) {
  const endRef = useRef(null);

  useEffect(() => {
    if (!enabled || count <= 0) return;
    const el = endRef.current;
    if (!el) return;
    const id = requestAnimationFrame(() => {
      try {
        el.scrollIntoView({ behavior: 'smooth', block: 'end' });
      } catch {
        el.scrollIntoView(true);
      }
    });
    return () => cancelAnimationFrame(id);
  }, [count, enabled]);

  return endRef;
}
